import React from "react";
import Select from "react-select";

const CustomOption = ({ innerProps, isDisabled, data }) => {
  return !isDisabled ? (
    <div className="lb-select-option" {...innerProps}>
      {/* your component internals */}
      {data.label}
    </div>
  ) : null;
};

export const LbSelect = ({
  options,
  isLoading = false,
  error = false,
  label = "",
  placeholder = "",
  value = null,
  onChange,
  onBlur,
  menuIsOpen,
  disabled = false,
  ...rest
}) => {
  return (
    <div className="form-group lb-select">
      {label && <label className="mb-8 label-01">{label}</label>}
      <Select
        isDisabled={disabled}
        className={`lb-select-container ${error ? " invalid " : ""}`}
        classNamePrefix="lb-select-menu"
        placeholder={placeholder}
        options={options}
        isLoading={isLoading}
        components={{ Option: CustomOption }}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        //  menuIsOpen={menuIsOpen}
        {...rest}
      />
    </div>
  );
};
